var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrentLocation = function SvgCurrentLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 54 54"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27 37.667c5.89 0 10.666-4.776 10.666-10.667 0-5.89-4.775-10.666-10.666-10.666S16.333 21.109 16.333 27 21.109 37.667 27 37.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.666 5.85V.334h-5.333v5.518A21.36 21.36 0 0 0 5.85 24.333H.333v5.334H5.85A21.355 21.355 0 0 0 24.333 48.15v5.517h5.333V48.15A21.35 21.35 0 0 0 48.15 29.667h5.517v-5.334H48.15A21.355 21.355 0 0 0 29.666 5.852M27 43c-8.824 0-16-7.176-16-16s7.176-16 16-16 16 7.176 16 16-7.176 16-16 16"
  })));
};
export default SvgCurrentLocation;